const TELEPHONE_STATUSES = {
    1: {
        text: 'Activo',
        type: 'success',
        id: 3
    },
    0: {
        text: 'Inactivo',
        type: 'dark',
        id: 2
    }
};

export default TELEPHONE_STATUSES;
